export const FEATURE_FLAG_179_ENABLE_FINALIZE_COLLECTION_LINK = false
export const FEATURE_FLAG_KD_285_ENABLE_RELATION_MODIFICATION = true

export const FEATURE_FLAG_KODI_392_SHOW_COLLECTION_PLAN_GROUP_EDITOR = true

export const ENABLE_WEBAUTHN = true
